import {AiOutlineFileText, AiOutlineLock, AiOutlineTeam} from 'react-icons/ai';
import {BiCategoryAlt} from 'react-icons/bi';
import {FaUsers} from 'react-icons/fa';
import {
  FaUsers as ClientsIcon,
  FaHouseChimneyUser,
  FaUsersBetweenLines,
  FaUsersGear,
} from 'react-icons/fa6';
import {MdOutlineCases} from 'react-icons/md';

import {
  ManageAdditionalServices,
  ManageAgeGroup,
  ManageBooking,
  ManageCaregiverPayrolls,
  ManageCaregiverQuotes,
  ManageCaregivers,
  ManageCareRecipients,
  ManageCases,
  ManageCategories,
  ManageCertificates,
  ManageClients,
  ManageDailyShifts,
  ManageLanguages,
  ManageRoles,
  ManageServices,
  ManageSubcategory,
  ManageUser,
} from 'src/shared/constants/permissions-enum';
import {FaRegCalendarAlt} from 'react-icons/fa';
import {RiCalendarCheckLine} from 'react-icons/ri';

const routesConfig = [
  {
    id: 'daily-shifts',
    title: 'daily-shifts',
    messageId: 'dailyShifts.sideBarName',
    icon: <RiCalendarCheckLine />,
    type: 'item',
    path: '/daily-shifts',
    permissionKey: ManageDailyShifts.List,
  },
  {
    id: 'caregivers',
    title: 'caregivers',
    messageId: 'caregivers.sideBarName',
    icon: <FaUsers />,
    type: 'item',
    path: '/caregivers',
    permissionKey: ManageCaregivers.List,
  },
  {
    id: 'caregiverQuotes',
    title: 'caregiverQuotes',
    messageId: 'caregiverQuotes.sideBarName',
    icon: <FaUsersBetweenLines />,
    type: 'item',
    path: '/caregiver-quotes',
    permissionKey: ManageCaregiverQuotes.List,
  },
  {
    id: 'signUps',
    title: 'signUps',
    messageId: 'signUps.sideBarName',
    icon: <FaUsersGear />,
    type: 'item',
    path: '/sign-ups',
    permissionKey: ManageClients.List,
  },
  {
    id: 'clients',
    title: 'clients',
    messageId: 'clients.sideBarName',
    icon: <ClientsIcon />,
    type: 'item',
    path: '/clients',
    permissionKey: ManageClients.List,
  },
  {
    id: 'care-recipients',
    title: 'care-recipients',
    messageId: 'careRecipients.sideBarName',
    icon: <FaHouseChimneyUser />,
    type: 'item',
    path: '/care-recipients',
    permissionKey: ManageCareRecipients.List,
  },
  {
    id: 'cases',
    title: 'cases',
    messageId: 'cases.sideBarName',
    icon: <MdOutlineCases />,
    type: 'item',
    path: '/cases',
    permissionKey: ManageCases.List,
  },
  {
    id: 'booking',
    title: 'booking',
    messageId: 'booking.sideBarName',
    icon: <FaRegCalendarAlt />,
    type: 'item',
    path: '/booking',
    permissionKey: ManageBooking.List,
  },
  {
    id: 'cms',
    title: 'cms',
    messageId: 'cms.sideBarName',
    icon: <BiCategoryAlt />,
    type: 'group',
    permissionKey: [
      ManageCategories.List,
      ManageSubcategory.List,
      ManageServices.List,
      ManageAdditionalServices.List,
    ],
    children: [
      {
        id: 'categories',
        title: 'categories',
        messageId: 'categories.sideBarName',
        type: 'item',
        path: '/cms/categories',
        permissionKey: ManageCategories.List,
      },
      {
        id: 'subcategory',
        title: 'subcategory',
        messageId: 'subcategory.sideBarName',
        type: 'item',
        path: '/cms/subcategory',
        permissionKey: ManageSubcategory.List,
      },
      {
        id: 'services',
        title: 'services',
        messageId: 'services.sideBarName',
        type: 'item',
        path: '/cms/services',
        permissionKey: ManageServices.List,
      },
      {
        id: 'age-group',
        title: 'age-group',
        messageId: 'ageGroup.sideBarName',
        type: 'item',
        path: '/cms/age-group',
        permissionKey: ManageAgeGroup.List,
      },
      {
        id: 'certificates',
        title: 'certificates',
        messageId: 'certificates.sideBarName',
        type: 'item',
        path: '/cms/certificates',
        permissionKey: ManageCertificates.List,
      },
      {
        id: 'languages',
        title: 'languages',
        messageId: 'languages.sideBarName',
        type: 'item',
        path: '/cms/languages',
        permissionKey: ManageLanguages.List,
      },
      // {
      //   id: 'additional-service',
      //   title: 'additional-service',
      //   messageId: 'additionalService.sideBarName',
      //   type: 'item',
      //   path: '/cms/additional-service',
      //   permissionKey: ManageAdditionalServices.List,
      // },
    ],
  },
  {
    id: 'caregivers-payrolls',
    title: 'caregivers-payrolls',
    messageId: 'caregiversPayrolls.sideBarName',
    icon: <AiOutlineFileText />,
    type: 'item',
    path: '/caregivers-payrolls',
    permissionKey: ManageCaregiverPayrolls.ReadCaregiverPayrollList,
  },
  {
    id: 'roles',
    title: 'roles',
    messageId: 'rolesManagement.sideBarName',
    icon: <AiOutlineLock />,
    type: 'item',
    path: '/roles',
    permissionKey: ManageRoles.List,
  },
  {
    id: 'users',
    title: 'users',
    messageId: 'usersManagement.sideBarName',
    icon: <AiOutlineTeam />,
    type: 'item',
    path: '/users',
    permissionKey: ManageUser.List,
  },
];
export default routesConfig;
